export default __webpack_public_path__ + "static/media/1819 knife block A top.7f4349ff.png";